const getAdminRealtimeNotificationTopics = () => [
    'from_admin.care_message.received_by_[USER_ID].created',
    'from_admin.care_room.user_[USER_ID].created',
];

export { getAdminRealtimeNotificationTopics };
